import 'bootstrap/dist/css/bootstrap.css'
import './App.css';
import {
  Routes,
  Route
} from 'react-router-dom'
import ServiceDetails from './Components/ServiceDetails';
import Services from './Pages/Services';
import About from './Pages/About';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import NotFound from './Pages/NotFound';
import ClientLayout from './Pages/ClientLayout';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeScreen } from './Store/viewSlice';

function App() {

  
  return (
    <Routes>
    <Route path='/'  element={<ClientLayout />}>
      <Route index element={<Home />} />
      <Route path='/home' element={<Home />} />
      <Route path='/about' element={<About />} />
      <Route path='/services' element={<Services />} />
      <Route path='/service-details' element={<ServiceDetails />} />
      <Route path='/contact' element={<Contact />} />
    </Route>
    <Route path='/*' element={<NotFound />} />
  </Routes>
  );
}

export default App;
